import Storefront from '.';
import * as queries from './queries';

const storefront = new Storefront();

export const decodeId = (id, type) =>
  parseInt(decodeURIComponent(id).split(`gid://shopify/${type}/`)[1], 10);

export const findGetParameter = (parameterName) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

export const getProductsByTag = async (tag) => {
  const response = await storefront.request({
    query: queries.productsByTag(tag, 250),
    variables: {
      countryCode: window.TMW.localization.countryCode,
      languageCode: window.TMW.localization.languageCode,
    },
  });
  return response;
};

export const getCollectionProducts = async (id, number) => {
    const response = await storefront.request({
      query: queries.collectionById,
      variables: {
        id,
        countryCode: window.TMW.localization.countryCode,
        languageCode: window.TMW.localization.languageCode,
        first: number || 250
      },
    });
    return response;
  };

export const getProductByHandle = async (handle) => {
  const response = await storefront.request({
    query: queries.productByHandle(),
    variables: {
      handle,
      countryCode: window.TMW.localization.countryCode,
      languageCode: window.TMW.localization.languageCode,
    },
  });
  return response;
};
